import { render, staticRenderFns } from "./RecordList.vue?vue&type=template&id=336fc852&scoped=true"
import script from "./RecordList.vue?vue&type=script&lang=js"
export * from "./RecordList.vue?vue&type=script&lang=js"
import style0 from "./RecordList.vue?vue&type=style&index=0&id=336fc852&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336fc852",
  null
  
)

export default component.exports